import { render } from "./ArgonButton.vue?vue&type=template&id=49c1e0d8&scoped=true"
import script from "./ArgonButton.vue?vue&type=script&lang=js"
export * from "./ArgonButton.vue?vue&type=script&lang=js"

import "./ArgonButton.vue?vue&type=style&index=0&id=49c1e0d8&scoped=true&lang=sass"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c1e0d8"]])

export default __exports__